import { systemProps, css } from "@bianic-ui/styled-system"
import createStyled from "@emotion/styled"
import { As, BianicComponent } from "./system.types"
import {
  pseudoProps,
  truncateProp,
  extraProps,
  domElements,
  DOMElements,
  cast,
} from "./system.utils"
import { shouldForwardProp } from "./should-forward-prop"
import { Dict } from "@bianic-ui/utils"

interface Options {
  shouldForwardProp?(prop: string): boolean
  label?: string
  baseStyle?: any
}

const sxProp = cast((props: any) => css(props.sx)(props.theme))
const cssProp = (props: any) => props.css

const __css = cast((props: Dict) => {
  const result = {} as Dict
  for (const key in props.__css) {
    const exists = key in props
    if (!exists || props[key] == null) {
      result[key] = props.__css[key]
    }
  }
  return css(result)(props.theme)
})

const base = cast((baseStyle: any) => (props: any) =>
  css(baseStyle)(props.theme),
)

export function styled<T extends As, P = {}>(component: T, options?: Options) {
  const { baseStyle, ...styledOptions } = options || {}
  return createStyled(component as any, {
    ...styledOptions,
    shouldForwardProp,
  })(
    __css,
    base(baseStyle),
    cast(extraProps),
    cast(truncateProp),
    cast(systemProps),
    cast(pseudoProps),
    sxProp,
    cast(cssProp),
  ) as BianicComponent<T, P>
}

type BianicJSXElements = {
  [Tag in DOMElements]: BianicComponent<Tag, {}>
}

type CreateBianicComponent = {
  <T extends As, P = {}>(component: T, options?: Options): BianicComponent<T, P>
}

export const bianic = (styled as unknown) as CreateBianicComponent &
  BianicJSXElements

domElements.forEach((tag) => {
  //@ts-ignore
  bianic[tag] = bianic(tag)
})
